export enum ChatChartType {
  Pie = 'pie',
}
